import React from 'react'

export function FlameKnight({ className = '', pose = 'idle' }) {
  return (
    <svg
      viewBox="0 0 200 300"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="fk-armorGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#b91c1c" />
          <stop offset="100%" stopColor="#7f1d1d" />
        </linearGradient>
        <linearGradient id="fk-goldGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fcd34d" />
          <stop offset="100%" stopColor="#b45309" />
        </linearGradient>
        <linearGradient id="fk-flameGrad" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#ea580c" />
          <stop offset="50%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#fef08a" stopOpacity="0" />
        </linearGradient>
        <filter id="fk-flameGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="fk-impactGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes fk-breathe {
            0%, 100% { transform: translateY(0) scaleY(1); }
            50% { transform: translateY(-3px) scaleY(1.02); }
          }
          @keyframes fk-flicker {
            0%, 100% { transform: scaleY(1) skewX(0deg); opacity: 0.9; }
            25% { transform: scaleY(1.1) skewX(2deg); opacity: 1; }
            50% { transform: scaleY(0.9) skewX(-2deg); opacity: 0.8; }
            75% { transform: scaleY(1.15) skewX(1deg); opacity: 1; }
          }
          @keyframes fk-slash {
            0% { transform: translateX(-10px) rotate(-10deg); }
            50% { transform: translateX(10px) rotate(5deg); }
            100% { transform: translateX(-10px) rotate(-10deg); }
          }
          @keyframes fk-float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }
          @keyframes fk-recoil {
            0%, 100% { transform: translateX(5px) rotate(5deg); }
            50% { transform: translateX(15px) rotate(10deg); }
          }
          @keyframes fk-flash {
            0%, 100% { opacity: 0; }
            50% { opacity: 0.8; }
          }
          @keyframes fk-brace {
            0%, 100% { transform: translateY(2px) scaleY(0.98); }
            50% { transform: translateY(0) scaleY(1); }
          }
          
          .fk-idle-anim { animation: fk-breathe 3s ease-in-out infinite; transform-origin: center 250px; }
          .fk-flame-anim { animation: fk-flicker 0.4s ease-in-out infinite alternate; transform-origin: bottom center; }
          .fk-attack-anim { animation: fk-slash 0.5s ease-in-out infinite; transform-origin: bottom center; }
          .fk-jump-anim { animation: fk-float 2s ease-in-out infinite; }
          .fk-hurt-anim { animation: fk-recoil 0.5s ease-in-out infinite; transform-origin: bottom center; }
          .fk-flash-anim { animation: fk-flash 0.5s infinite; }
          .fk-block-anim { animation: fk-brace 2s ease-in-out infinite; transform-origin: bottom center; }
        `}
      </style>

      {pose === 'idle' && (
        <g className="fk-idle-anim">
          {/* Back Arm & Sword */}
          <g transform="translate(130, 120)">
            <path d="M0 0 L30 40 L20 50 L-10 10 Z" fill="url(#fk-armorGrad)" />
            <path d="M20 40 L100 -60 L110 -50 L30 50 Z" fill="#cbd5e1" />
            <path
              d="M25 35 Q 60 -20 105 -65 Q 80 -10 35 45 Z"
              fill="url(#fk-flameGrad)"
              filter="url(#fk-flameGlow)"
              className="fk-flame-anim"
            />
            <rect
              x="10"
              y="35"
              width="30"
              height="10"
              transform="rotate(45 25 40)"
              fill="url(#fk-goldGrad)"
            />
          </g>
          {/* Legs */}
          <path
            d="M70 180 L50 260 L80 260 L90 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M130 180 L150 260 L120 260 L110 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M40 260 L85 260 L80 280 L30 280 Z"
            fill="url(#fk-goldGrad)"
          />
          <path
            d="M115 260 L160 260 L170 280 L120 280 Z"
            fill="url(#fk-goldGrad)"
          />
          {/* Torso */}
          <path
            d="M60 80 L140 80 L120 190 L80 190 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M70 90 L130 90 L115 140 L85 140 Z"
            fill="url(#fk-goldGrad)"
          />
          {/* Shoulders */}
          <path d="M40 70 Q 70 40 100 70 Z" fill="url(#fk-goldGrad)" />
          <path d="M100 70 Q 130 40 160 70 Z" fill="url(#fk-goldGrad)" />
          <path
            d="M50 60 Q 70 10 90 60 Z"
            fill="url(#fk-flameGrad)"
            filter="url(#fk-flameGlow)"
            className="fk-flame-anim"
          />
          <path
            d="M110 60 Q 130 10 150 60 Z"
            fill="url(#fk-flameGrad)"
            filter="url(#fk-flameGlow)"
            className="fk-flame-anim"
            style={{ animationDelay: '0.1s' }}
          />
          {/* Head */}
          <g transform="translate(100, 50)">
            <path
              d="M-25 0 C -25 -30 25 -30 25 0 L 20 30 L -20 30 Z"
              fill="url(#fk-armorGrad)"
            />
            <path
              d="M-15 5 L 15 5 L 5 20 L -5 20 Z"
              fill="#fef08a"
              filter="url(#fk-flameGlow)"
            />
            <path
              d="M-10 -25 Q 0 -60 30 -40 Q 10 -30 10 -25 Z"
              fill="url(#fk-flameGrad)"
              className="fk-flame-anim"
            />
          </g>
          {/* Front Arm */}
          <path d="M60 80 L30 130 L50 140 L75 95 Z" fill="url(#fk-armorGrad)" />
          <circle cx="40" cy="135" r="15" fill="url(#fk-goldGrad)" />
        </g>
      )}

      {pose === 'attack' && (
        <g className="fk-attack-anim">
          {/* Wide stance legs */}
          <path
            d="M80 180 L30 260 L60 260 L100 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M120 180 L170 260 L140 260 L100 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M20 260 L65 260 L60 280 L10 280 Z"
            fill="url(#fk-goldGrad)"
          />
          <path
            d="M130 260 L175 260 L185 280 L135 280 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Torso leaning forward */}
          <path
            d="M70 90 L150 90 L120 190 L80 190 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M80 100 L140 100 L115 140 L85 140 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Head looking forward */}
          <g transform="translate(120, 60) rotate(15)">
            <path
              d="M-25 0 C -25 -30 25 -30 25 0 L 20 30 L -20 30 Z"
              fill="url(#fk-armorGrad)"
            />
            <path
              d="M-5 5 L 20 5 L 15 20 L 5 20 Z"
              fill="#fef08a"
              filter="url(#fk-flameGlow)"
            />
            <path
              d="M-10 -25 Q -30 -50 0 -40 Q -10 -30 -10 -25 Z"
              fill="url(#fk-flameGrad)"
              className="fk-flame-anim"
            />
          </g>

          {/* Shoulders */}
          <path d="M50 80 Q 80 50 110 80 Z" fill="url(#fk-goldGrad)" />
          <path d="M110 80 Q 140 50 170 80 Z" fill="url(#fk-goldGrad)" />

          {/* Back arm */}
          <path
            d="M70 90 L40 130 L60 140 L85 105 Z"
            fill="url(#fk-armorGrad)"
          />

          {/* Front arm & Sword Slash */}
          <g transform="translate(140, 100)">
            <path d="M0 0 L40 -10 L45 5 L5 15 Z" fill="url(#fk-armorGrad)" />
            <circle cx="45" cy="-2" r="15" fill="url(#fk-goldGrad)" />
            {/* Sword extended */}
            <path d="M45 -2 L160 -2 L160 8 L45 8 Z" fill="#cbd5e1" />
            {/* Massive Flame Arc */}
            <path
              d="M40 -10 Q 100 -60 180 -10 Q 120 -20 40 10 Z"
              fill="url(#fk-flameGrad)"
              filter="url(#fk-flameGlow)"
              className="fk-flame-anim"
            />
            <path
              d="M60 -30 Q 120 -80 190 0 Q 130 -40 60 -10 Z"
              fill="url(#fk-flameGrad)"
              filter="url(#fk-flameGlow)"
              className="fk-flame-anim"
              style={{ animationDelay: '0.2s' }}
              opacity="0.7"
            />
          </g>
        </g>
      )}

      {pose === 'jump' && (
        <g className="fk-jump-anim">
          {/* Tucked Legs */}
          <path
            d="M80 180 L70 220 L100 220 L100 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M120 180 L130 220 L100 220 L100 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M60 220 L105 220 L100 240 L50 240 Z"
            fill="url(#fk-goldGrad)"
          />
          <path
            d="M95 220 L140 220 L150 240 L100 240 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Torso */}
          <path
            d="M60 80 L140 80 L120 190 L80 190 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M70 90 L130 90 L115 140 L85 140 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Shoulders */}
          <path d="M40 70 Q 70 40 100 70 Z" fill="url(#fk-goldGrad)" />
          <path d="M100 70 Q 130 40 160 70 Z" fill="url(#fk-goldGrad)" />

          {/* Downward Flames */}
          <path
            d="M50 70 Q 70 120 90 70 Z"
            fill="url(#fk-flameGrad)"
            filter="url(#fk-flameGlow)"
            className="fk-flame-anim"
          />
          <path
            d="M110 70 Q 130 120 150 70 Z"
            fill="url(#fk-flameGrad)"
            filter="url(#fk-flameGlow)"
            className="fk-flame-anim"
            style={{ animationDelay: '0.1s' }}
          />

          {/* Head looking up */}
          <g transform="translate(100, 40) rotate(-10)">
            <path
              d="M-25 0 C -25 -30 25 -30 25 0 L 20 30 L -20 30 Z"
              fill="url(#fk-armorGrad)"
            />
            <path
              d="M-15 0 L 15 0 L 10 15 L -10 15 Z"
              fill="#fef08a"
              filter="url(#fk-flameGlow)"
            />
            <path
              d="M-10 -25 Q 0 -10 30 -20 Q 10 -15 10 -25 Z"
              fill="url(#fk-flameGrad)"
              className="fk-flame-anim"
            />
          </g>

          {/* Arms holding sword overhead */}
          <path d="M60 80 L80 30 L100 40 L75 95 Z" fill="url(#fk-armorGrad)" />
          <path
            d="M140 80 L120 30 L100 40 L125 95 Z"
            fill="url(#fk-armorGrad)"
          />
          <circle cx="100" cy="35" r="15" fill="url(#fk-goldGrad)" />

          {/* Sword overhead */}
          <g transform="translate(100, 35) rotate(-90)">
            <path d="M10 -5 L100 -5 L110 0 L100 5 L10 5 Z" fill="#cbd5e1" />
            <path
              d="M15 -10 Q 60 -30 105 -5 Q 80 0 35 10 Z"
              fill="url(#fk-flameGrad)"
              filter="url(#fk-flameGlow)"
              className="fk-flame-anim"
            />
          </g>
        </g>
      )}

      {pose === 'hurt' && (
        <g className="fk-hurt-anim">
          {/* Impact Flash */}
          <circle
            cx="100"
            cy="120"
            r="60"
            fill="#ef4444"
            filter="url(#fk-impactGlow)"
            className="fk-flash-anim"
          />

          {/* Recoiling Legs */}
          <path
            d="M90 180 L110 260 L140 260 L110 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M130 180 L160 250 L180 240 L140 170 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M100 260 L145 260 L140 280 L90 280 Z"
            fill="url(#fk-goldGrad)"
          />
          <path
            d="M150 245 L190 235 L195 255 L155 265 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Torso leaning back */}
          <path
            d="M80 80 L160 90 L130 190 L90 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M90 90 L150 100 L125 140 L95 130 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Head thrown back */}
          <g transform="translate(130, 40) rotate(30)">
            <path
              d="M-25 0 C -25 -30 25 -30 25 0 L 20 30 L -20 30 Z"
              fill="url(#fk-armorGrad)"
            />
            <path d="M-15 5 L 15 5 L 5 20 L -5 20 Z" fill="#fef08a" />
            <path
              d="M-10 -25 Q -30 -10 -40 10 Q -20 -10 -10 -25 Z"
              fill="url(#fk-flameGrad)"
              className="fk-flame-anim"
            />
          </g>

          {/* Arms thrown back */}
          <path d="M80 80 L30 60 L40 40 L90 70 Z" fill="url(#fk-armorGrad)" />
          <path
            d="M160 90 L200 120 L190 140 L150 100 Z"
            fill="url(#fk-armorGrad)"
          />

          {/* Dropped sword */}
          <g transform="translate(190, 130) rotate(120)">
            <path d="M0 0 L80 0 L90 5 L80 10 L0 10 Z" fill="#cbd5e1" />
            <rect
              x="-10"
              y="-5"
              width="10"
              height="20"
              fill="url(#fk-goldGrad)"
            />
          </g>
        </g>
      )}

      {pose === 'block' && (
        <g className="fk-block-anim">
          {/* Crouched Legs */}
          <path
            d="M60 180 L40 240 L70 240 L80 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M120 180 L140 240 L110 240 L100 180 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M30 240 L75 240 L70 260 L20 260 Z"
            fill="url(#fk-goldGrad)"
          />
          <path
            d="M105 240 L150 240 L160 260 L110 260 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Crouched Torso */}
          <path
            d="M50 100 L130 100 L110 190 L70 190 Z"
            fill="url(#fk-armorGrad)"
          />
          <path
            d="M60 110 L120 110 L105 150 L75 150 Z"
            fill="url(#fk-goldGrad)"
          />

          {/* Head tucked */}
          <g transform="translate(90, 70) rotate(-15)">
            <path
              d="M-25 0 C -25 -30 25 -30 25 0 L 20 30 L -20 30 Z"
              fill="url(#fk-armorGrad)"
            />
            <path
              d="M-15 5 L 15 5 L 5 20 L -5 20 Z"
              fill="#fef08a"
              filter="url(#fk-flameGlow)"
            />
            <path
              d="M-10 -25 Q 20 -40 40 -20 Q 10 -20 10 -25 Z"
              fill="url(#fk-flameGrad)"
              className="fk-flame-anim"
            />
          </g>

          {/* Back arm holding sword behind */}
          <g transform="translate(130, 120)">
            <path d="M0 0 L30 20 L20 30 L-10 10 Z" fill="url(#fk-armorGrad)" />
            <path d="M20 20 L80 80 L70 90 L10 30 Z" fill="#cbd5e1" />
          </g>

          {/* Front arm with Shield */}
          <path
            d="M50 100 L20 130 L40 140 L65 115 Z"
            fill="url(#fk-armorGrad)"
          />
          <g transform="translate(20, 130)">
            <circle
              cx="0"
              cy="0"
              r="40"
              fill="url(#fk-armorGrad)"
              stroke="url(#fk-goldGrad)"
              strokeWidth="8"
            />
            <circle cx="0" cy="0" r="20" fill="url(#fk-goldGrad)" />
            {/* Shield Glow */}
            <circle
              cx="0"
              cy="0"
              r="45"
              fill="none"
              stroke="#fcd34d"
              strokeWidth="4"
              filter="url(#fk-flameGlow)"
              className="fk-flame-anim"
            />
          </g>
        </g>
      )}
    </svg>
  )
}
